var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(" Ver máximo de a "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valorActual,
            expression: "valorActual"
          }
        ],
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.valorActual = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          }
        }
      },
      _vm._l(_vm.opciones, function(opcion) {
        return _c(
          "option",
          {
            key: opcion.nombre,
            domProps: {
              selected: opcion.valor == _vm.valorActual,
              value: opcion.valor
            }
          },
          [_vm._v(" " + _vm._s(opcion.valor) + " ")]
        )
      }),
      0
    ),
    _vm._v(" registros por página ")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }